export const balloonPositionMap = new Map([
    ['left', 'up-left'],
    ['center', 'up'],
    ['right', 'up-right'],
]);
